export default __webpack_public_path__ + "static/media/title.34a15660.jpg";